export const TEST_ID = 'dronesGrid';

export const INITIAL_REFRESH_TOKEN = 0;
